<template>
	<div class="content-wrapper">
		<div id="temperatureChart"></div>
		<div id="voltageChart"></div>
		<div id="sohChart"></div>
	</div>
</template>

<script>
	//单体最高温度
	var TemperatureData = {
		"status": "succeed",
		"data": {
			"week": [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28],
			"data": [8.2, 12.14, 17.65, 22.2, 26.89, 25.29, 22.59, 23.53, 26.25, 27.53, 25.37, 24.95, 33.35, 38.76,
				40.6, 40.89, 40.95, 40.42, 35.22, 39.54, 40.95, 35.85, 36.96, 35.95, 38.12, 45.12
			]
		}
	};

	var VoltageData = {
		"status": "succeed",
		"data": {
			"dateArray": ["2019-5-16", "2019-5-17", "2019-5-18", "2019-5-19", "2019-5-20", "2019-5-21", "2019-5-22",
				"2019-5-23", "2019-5-24", "2019-5-25", "2019-5-26", "2019-5-27", "2019-5-28", "2019-5-29",
				"2019-5-30", "2019-5-31", "2019-6-1", "2019-6-2", "2019-6-3", "2019-6-4", "2019-6-5", "2019-6-6",
				"2019-6-7", "2019-6-8", "2019-6-9", "2019-6-10", "2019-6-11", "2019-6-12", "2019-6-13",
				"2019-6-14", "2019-6-15", "2019-6-16", "2019-6-17", "2019-6-18", "2019-6-19", "2019-6-20",
				"2019-6-21", "2019-6-22"
			],
			"previousData": [5.5423, 22, 17.6301, 40.1361, 28, 34.938, 40.5925, 61.6669, 39, 60.008, 43, 54.2303,
				65.9781, 74.5057, 97.4686, 60, 101.8064, 108.9309, 112.8949, 113.2444, 143.8364, 138.2602,
				121.0798, 155.3736, 158, 159.3098, 171, 181, 188, 196, 204.5, 203.9888, 221.4499
			],
			"forecastData": ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "",
				"", "", "", "", "", "", "", "", "", "", 221.4499, 232.7422, 249.0046, 265.4168, 283.9788, 301.6907
			]
		}
	};

	var SOHData = {
		"status": "succeed",
		"data": {
			"dateArray": ["2018-9-19", "2018-9-20", "2018-9-21", "2018-9-22", "2018-9-23", "2018-9-24", "2018-9-25",
				"2018-9-26", "2018-9-27", "2018-9-28", "2018-9-29", "2018-9-30", "2018-10-1", "2018-10-2",
				"2018-10-3", "2018-10-4", "2018-10-5", "2018-10-6", "2018-10-7", "2018-10-8", "2018-10-9",
				"2018-10-10", "2018-10-11", "2018-10-12", "2018-10-13", "2018-10-14", "2018-10-15", "2018-10-16",
				"2018-10-17", "2018-10-18", "2018-10-19", "2018-10-20", "2018-10-21", "2018-10-22", "2018-10-23",
				"2018-10-24", "2018-10-25", "2018-10-26", "2018-10-27", "2018-10-28", "2018-10-29", "2018-10-30",
				"2018-10-31", "2018-11-1", "2018-11-2", "2018-11-3", "2018-11-4", "2018-11-5", "2018-11-6",
				"2018-11-7", "2018-11-8", "2018-11-9", "2018-11-10", "2018-11-11", "2018-11-12", "2018-11-13",
				"2018-11-14", "2018-11-15", "2018-11-16", "2018-11-17", "2018-11-18", "2018-11-19", "2018-11-20",
				"2018-11-21", "2018-11-22", "2018-11-23", "2018-11-24", "2018-11-25", "2018-11-26", "2018-11-27",
				"2018-11-28", "2018-11-29", "2018-11-30", "2018-12-1", "2018-12-2", "2018-12-3", "2018-12-4",
				"2018-12-5", "2018-12-6", "2018-12-7", "2018-12-8", "2018-12-9", "2018-12-10", "2018-12-11",
				"2018-12-12", "2018-12-13", "2018-12-14", "2018-12-15", "2018-12-16", "2018-12-17", "2018-12-18",
				"2018-12-19", "2018-12-20", "2018-12-21", "2018-12-22", "2018-12-23", "2018-12-24", "2018-12-25",
				"2018-12-26", "2018-12-27", "2018-12-28", "2018-12-29", "2018-12-30", "2018-12-31", "2019-1-1",
				"2019-1-2", "2019-1-3", "2019-1-4", "2019-1-5", "2019-1-6", "2019-1-7", "2019-1-8", "2019-1-9",
				"2019-1-10", "2019-1-11", "2019-1-12", "2019-1-13", "2019-1-14", "2019-1-15", "2019-1-16",
				"2019-1-17", "2019-1-18", "2019-1-19", "2019-1-20", "2019-1-21", "2019-1-22", "2019-1-23",
				"2019-1-24", "2019-1-25", "2019-1-26", "2019-1-27", "2019-1-28", "2019-1-29", "2019-1-30",
				"2019-1-31", "2019-2-1", "2019-2-2", "2019-2-3", "2019-2-4", "2019-2-5", "2019-2-6", "2019-2-7",
				"2019-2-8", "2019-2-9", "2019-2-10", "2019-2-11", "2019-2-12", "2019-2-13", "2019-2-14",
				"2019-2-15", "2019-2-16", "2019-2-17", "2019-2-18", "2019-2-19", "2019-2-20", "2019-2-21",
				"2019-2-22", "2019-2-23", "2019-2-24", "2019-2-25", "2019-2-26", "2019-2-27", "2019-2-28",
				"2019-3-1", "2019-3-2", "2019-3-3", "2019-3-4", "2019-3-5", "2019-3-6", "2019-3-7", "2019-3-8",
				"2019-3-9", "2019-3-10", "2019-3-11", "2019-3-12", "2019-3-13", "2019-3-14", "2019-3-15",
				"2019-3-16", "2019-3-17", "2019-3-18", "2019-3-19", "2019-3-20", "2019-3-21", "2019-3-22",
				"2019-3-23", "2019-3-24", "2019-3-25", "2019-3-26", "2019-3-27", "2019-3-28", "2019-3-29",
				"2019-3-30", "2019-3-31", "2019-4-1", "2019-4-2", "2019-4-3", "2019-4-4", "2019-4-5", "2019-4-6",
				"2019-4-7", "2019-4-8", "2019-4-9", "2019-4-10", "2019-4-11", "2019-4-12", "2019-4-13",
				"2019-4-14", "2019-4-15", "2019-4-16", "2019-4-17", "2019-4-18", "2019-4-19", "2019-4-20",
				"2019-4-21", "2019-4-22", "2019-4-23", "2019-4-24", "2019-4-25", "2019-4-26", "2019-4-27",
				"2019-4-28", "2019-4-29", "2019-4-30", "2019-5-1", "2019-5-2", "2019-5-3", "2019-5-4", "2019-5-5",
				"2019-5-6", "2019-5-7", "2019-5-8", "2019-5-9", "2019-5-10", "2019-5-11", "2019-5-12", "2019-5-13",
				"2019-5-14", "2019-5-15", "2019-5-16", "2019-5-17", "2019-5-18", "2019-5-19", "2019-5-20",
				"2019-5-21", "2019-5-22", "2019-5-23", "2019-5-24", "2019-5-25", "2019-5-26", "2019-5-27",
				"2019-5-28", "2019-5-29", "2019-5-30", "2019-5-31", "2019-6-1", "2019-6-2", "2019-6-3", "2019-6-4",
				"2019-6-5", "2019-6-6", "2019-6-7", "2019-6-8", "2019-6-9", "2019-6-10", "2019-6-11", "2019-6-12",
				"2019-6-13", "2019-6-14", "2019-6-15", "2019-6-16", "2019-6-17", "2019-6-18", "2019-6-19",
				"2019-6-20", "2019-6-21", "2019-6-22", "2019-6-23", "2019-6-24", "2019-6-25", "2019-6-26",
				"2019-6-27", "2019-6-28", "2019-6-29", "2019-6-30", "2019-7-1", "2019-7-2", "2019-7-3", "2019-7-4",
				"2019-7-5", "2019-7-6", "2019-7-7", "2019-7-8", "2019-7-9", "2019-7-10", "2019-7-11", "2019-7-12",
				"2019-7-13", "2019-7-14", "2019-7-15", "2019-7-16", "2019-7-17", "2019-7-18", "2019-7-19",
				"2019-7-20", "2019-7-21", "2019-7-22", "2019-7-23", "2019-7-24", "2019-7-25", "2019-7-26",
				"2019-7-27", "2019-7-28", "2019-7-29", "2019-7-30", "2019-7-31", "2019-8-1", "2019-8-2",
				"2019-8-3", "2019-8-4", "2019-8-5", "2019-8-6", "2019-8-7", "2019-8-8", "2019-8-9", "2019-8-10",
				"2019-8-11", "2019-8-12", "2019-8-13", "2019-8-14", "2019-8-15", "2019-8-16", "2019-8-17",
				"2019-8-18", "2019-8-19", "2019-8-20", "2019-8-21", "2019-8-22", "2019-8-23", "2019-8-24",
				"2019-8-25", "2019-8-26", "2019-8-27", "2019-8-28", "2019-8-29", "2019-8-30", "2019-8-31",
				"2019-9-1", "2019-9-2", "2019-9-3", "2019-9-4", "2019-9-5", "2019-9-6", "2019-9-7", "2019-9-8",
				"2019-9-9", "2019-9-10", "2019-9-11", "2019-9-12", "2019-9-13", "2019-9-14", "2019-9-15",
				"2019-9-16", "2019-9-17"
			],
			"previousData": [100, 99.9872, 99.9745, 99.9619, 99.9495, 99.9371, 99.9247, 99.9125, 99.9004, 99.8884,
				99.8765, 99.8646, 99.8529, 99.8412, 99.8297, 99.8182, 99.8068, 99.7956, 99.7844, 99.7733, 99.7622,
				99.7513, 99.7405, 99.7297, 99.7191, 99.7085, 99.698, 99.6876, 99.6773, 99.667, 99.6569, 99.6468,
				99.6369, 99.627, 99.6172, 99.6075, 99.5978, 99.5883, 99.5788, 99.5694, 99.5601, 99.5509, 99.5417,
				99.5327, 99.5237, 99.5148, 99.506, 99.4972, 99.4885, 99.48, 99.4714, 99.463, 99.4547, 99.4464,
				99.4382, 99.43, 99.422, 99.414, 99.4061, 99.3982, 99.3904, 99.3826, 99.3749, 99.3672, 99.3596,
				99.352, 99.3445, 99.3371, 99.3297, 99.3223, 99.3151, 99.3079, 99.3007, 99.2936, 99.2866, 99.2796,
				99.2727, 99.2659, 99.2591, 99.2524, 99.2457, 99.2392, 99.2327, 99.2262, 99.2198, 99.2135, 99.2073,
				99.2011, 99.195, 99.189, 99.1831, 99.1772, 99.1714, 99.1657, 99.16, 99.1545, 99.149, 99.1435,
				99.1382, 99.1329, 99.1278, 99.1227, 99.1176, 99.1127, 99.1078, 99.1031, 99.0984, 99.0938, 99.0893,
				99.0848, 99.0805, 99.0762, 99.072, 99.0679, 99.064, 99.06, 99.0562, 99.0525, 99.0489, 99.0453,
				99.0419, 99.0385, 99.0353, 99.0321, 99.029, 99.0261, 99.0232, 99.0204, 99.0178, 99.0152, 99.0127,
				99.0103, 99.008, 99.0059, 99.0038, 99.0018, 99, 98.9982, 98.9966, 98.995, 98.9936, 98.9923, 98.991,
				98.9899, 98.9889, 98.988, 98.9872, 98.9866, 98.986, 98.9856, 98.9852, 98.985, 98.9849, 98.9849,
				98.9851, 98.9853, 98.9857, 98.9861, 98.9868, 98.9875, 98.9883, 98.9893, 98.9904, 98.9916, 98.9929,
				98.9944, 98.9959, 98.9977, 98.9995, 99.0014, 99.0035, 99.0057, 99.0081, 99.0106, 99.0132, 99.0159,
				99.0188, 99.0218, 99.0249, 99.0282, 99.0316, 99.0351, 99.0388, 99.0423, 99.0455, 99.0484, 99.051,
				99.0532, 99.0551, 99.0567, 99.058, 99.059, 99.0597, 99.0602, 99.0604, 99.0603, 99.06, 99.0594,
				99.0586, 99.0576, 99.0564, 99.0549, 99.0533, 99.0514, 99.0494, 99.0472, 99.0448, 99.0423, 99.0396,
				99.0367, 99.0337, 99.0306, 99.0274, 99.0241, 99.0206, 99.0171, 99.0134, 99.0097, 99.0059, 99.0021,
				98.9982, 98.9942, 98.9902, 98.9862, 98.9821, 98.9776, 98.9721, 98.9658, 98.9587, 98.9509, 98.9425,
				98.9335, 98.924, 98.9141, 98.9039, 98.8933, 98.8826, 98.8717, 98.8608, 98.8498, 98.839, 98.8283,
				98.8178, 98.8076, 98.7977, 98.7883, 98.7794, 98.7711, 98.7634, 98.7564, 98.7502, 98.7449, 98.7403,
				98.7365, 98.7332, 98.7305, 98.7283, 98.7266, 98.7254, 98.7245, 98.7239, 98.7237, 98.7237, 98.7239,
				98.7243, 98.7248, 98.7253, 98.7259, 98.7265, 98.727, 98.7274, 98.7276
			],
			"forecastData": ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "",
				"", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "",
				"", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "",
				"", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "",
				"", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "",
				"", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "",
				"", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "",
				"", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "",
				"", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "",
				"", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "",
				"", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "",
				98.7276, 98.7276, 98.7274, 98.7269, 98.7261, 98.7248, 98.7232, 98.7211, 98.7188, 98.7167, 98.7147,
				98.713, 98.7113, 98.7098, 98.7084, 98.707, 98.7057, 98.7044, 98.7032, 98.7019, 98.7007, 98.6994,
				98.6981, 98.6967, 98.6952, 98.6936, 98.6919, 98.69, 98.688, 98.6858, 98.6834, 98.6808, 98.678,
				98.6749, 98.6716, 98.6679, 98.6641, 98.6604, 98.6566, 98.6528, 98.649, 98.6451, 98.6413, 98.6374,
				98.6334, 98.6294, 98.6253, 98.6212, 98.617, 98.6128, 98.6084, 98.604, 98.5994, 98.5948, 98.59,
				98.5852, 98.5802, 98.5751, 98.5698, 98.5644, 98.5589, 98.5532, 98.5473, 98.5414, 98.5353, 98.529,
				98.5227, 98.5162, 98.5096, 98.5029, 98.4961, 98.4891, 98.4821, 98.4749, 98.4676, 98.4602, 98.4527,
				98.4451, 98.4374, 98.4296, 98.4217, 98.4137, 98.4056, 98.3974, 98.3891, 98.3807, 98.3723, 98.3637,
				98.3551, 98.3464, 98.3376, 98.3288, 98.3198
			]
		}
	};


	export default {
		data() {
			return {
				Temperature: TemperatureData.data,
				Voltage: VoltageData.data,
				SOH: SOHData.data,
			}
		},
		mounted() {
			//SOH衰减曲线
			let list2 = [];
			var qunina = new Date();
			let sohstr = qunina.setDate(qunina.getDate() - 270);
			for (var i = 1; i < 365; i++) {
				let str = new Date(sohstr + 86400000 * i);
				list2.push(str.getFullYear() + "-" + (str.getMonth() + 1) + "-" + str.getDate());
			}
			this.SOH.dateArray = list2;
			this.SOH.strtime = list2[271].replaceAll('/', '-');
			this.SOH.endtime = list2[list2.length - 1].replaceAll('/', '-');

			//单体最大压差
			console.log(this.Voltage)
			let list3 = [];
			var yacha = new Date();
			let volstr = yacha.setDate(yacha.getDate() - 33);
			for (var i = 1; i <= 38; i++) {
				let str = new Date(volstr + 86400000 * i);
				list3.push(str.getFullYear() + "-" + (str.getMonth() + 1) + "-" + str.getDate());
			}
			this.Voltage.dateArray = list3;
			this.Voltage.strtime = list3[32].replaceAll('/', '-');
			this.Voltage.endtime = list3[list3.length - 1].replaceAll('/', '-');

			this.onTemperatureChart();
			this.onVoltageChart();
			this.onSohChart();
		},
		methods: {
			onTemperatureChart: function() { //单体最高温度
				let self = this;
				var data = self.Temperature.data;
				var data1 = [],
					data2 = [];
				for (var i = 0; i < data.length; i++) {
					if (i < 22) {
						data1.push(data[i]);
						data2.push('');
					} else {
						data1.push('');
						data2.push(data[i]);
					}
				}
				data2[21] = data1[21];
				var myChart = this.$echarts.init(document.getElementById("temperatureChart"));
				var option = {
					title: {
						text: '单体最高温度',
						left: 'center',
						textStyle: {
							color: '#fff',
							fontSize: '25'
						}
					},
					grid: {
						top: 60,
						bottom: 50
					},
					xAxis: {
						name: '周',
						type: 'category',
						data: self.Temperature.week,
						axisTick: {
							alignWithLabel: true
						},
						axisLabel: {
							show: true,
							textStyle: {
								color: '#fff'
							}
						},
						axisLine: {
							show: false,
							lineStyle: {
								color: '#fff'
							},
						},
						// splitArea: {
						// 	show: true,
						// 	interval: function(index, value) {
						// 		return value > 24;
						// 	},
						// 	areaStyle: {
						// 		color: ['rgba(19, 18, 18, 0.1)', 'rgb(163, 114, 0,0.3)']
						// 	}
						// },
						interval: '100', //表示全部显示不间隔,auto:表示自动根据刻度个数和宽度自动设置间隔个数
					},
					yAxis: {
						name: '℃',
						show: true,
						max: 60,
						axisLine: {
							show: false,
							lineStyle: {
								color: '#fff'
							},
						},
						axisTick: {
							show: false
						},
						axisLabel: {
							show: true,
							textStyle: {
								color: '#fff'
							}
						},
						splitLine: {
							lineStyle: {
								// color: 'gray',
								color: ['gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'red'],
							},
						},
						type: 'value',
					},
					tooltip: {
						backgroundColor :'rgba(50,50,50,0.7)',
						borderColor :'transparent',
						alwaysShowContent: true,
						trigger: 'axis',
						// axisPointer: {
						// 	type: 'cross', //十字准星指示器
						// },
						formatter: function(params) {
							var result =
								'<div style="border-top: 2px solid orange;text-align: center;border-bottom: 2px solid orange;padding: 10px 0px;"><span style="color: white;font-size: 16px;display: block;margin-bottom:5px;">温度℃</span><span style="display:block;font-size: 34px;color:orange;font-weight: bold;">' +
								(params[0].data==''?params[1].data:params[0].data) + '</span></div>';
							return result;
						},
					},
					series: [{
						data: data1,
						type: 'line',
						color: 'white',
						symbol: 'none',
					}, {
						data: data2,
						type: 'line',
						color: 'orange',
						symbol: 'none',
						markArea: {
							silent: true,
							data: [
								[{
									xAxis: '24'
								}, {
									xAxis: '28'
								}]
							]
						},
					}]
				};
				if (option && typeof option === "object") {
					myChart.setOption(option, true);
				}
				//默认显示详情框
				myChart.dispatchAction({
					type: 'showTip',
					x: 10, // 屏幕上的 x 坐标
					y: 10, // 屏幕上的 y 坐标
					seriesIndex: 0,
					dataIndex: 20,
					// 本次显示 tooltip 的位置。只在本次 action 中生效。
					// 缺省则使用 option 中定义的 tooltip 位置。
					position: function(point, params, dom, rect, size) {
						return {
							right: '15%',
							top: '15%'
						};
					}
				});
				window.addEventListener("resize", function() {
					myChart.resize();
				});
			},
			onVoltageChart: function() { //单体最大压差
				let self = this;
				var myChart = this.$echarts.init(document.getElementById("voltageChart"));
				var option = {
					title: {
						text: '单体最大压差',
						left: 'center',
						textStyle: {
							color: '#fff',
							fontSize: '25'
						}
					},
					grid: {
						top: 60,
						bottom: 50
					},
					xAxis: {
						type: 'category',
						data: self.Voltage.dateArray,
						axisTick: {
							alignWithLabel: true
						},
						axisLabel: {
							show: true,
							textStyle: {
								color: '#fff'
							}
						},
						axisLine: {
							show: false,
							lineStyle: {
								color: '#fff'
							},
						},
						// splitArea: {
						// 	show: true,
						// 	interval: function(index, value) {
						// 		return index > 31;
						// 	},
						// 	areaStyle: {
						// 		color: ['rgba(19, 18, 18, 0.1)', 'rgb(163, 114, 0,0.3)']
						// 	}
						// },
						interval: '100', //表示全部显示不间隔,auto:表示自动根据刻度个数和宽度自动设置间隔个数
					},
					yAxis: {
						name: 'mv',
						show: true,
						max: 350,
						interval: 50,
						axisLine: {
							show: false,
							lineStyle: {
								color: '#fff'
							},
						},
						axisTick: {
							show: false
						},
						axisLabel: {
							show: true,
							textStyle: {
								color: '#fff'
							}
						},
						splitLine: {
							lineStyle: {
								color: ['gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'red'],
							},
						},
						type: 'value',
					},
					tooltip: {
						backgroundColor :'rgba(50,50,50,0.7)',
						borderColor :'transparent',
						alwaysShowContent: true, //永远显示提示框内容
						trigger: 'axis',
						// axisPointer: {
						// 	type: 'cross', //十字准星指示器
						// },
						formatter: function(params) {
							var result =
								'<div style="border-top: 2px solid orange;text-align: center;border-bottom: 2px solid orange;padding: 10px 0px;"><span style="color: white;font-size: 16px;display: block;margin-bottom:5px;">压差mv</span><span style="display:block;font-size: 34px;color:orange;font-weight: bold;">' +
								params[0].data + '</span></div>';
							return result;
						},
					},
					series: [{
						data: self.Voltage.previousData,
						type: 'line',
						color: 'white',
						symbol: 'none'
					}, {
						data: self.Voltage.forecastData,
						type: 'line',
						color: 'orange',
						symbol: 'none',
						markArea: {
							silent: true,
							data: [
								[{
									xAxis: self.Voltage.strtime
								}, {
									xAxis: self.Voltage.endtime
								}]
							]
						},
					}]
				};
				if (option && typeof option === "object") {
					myChart.setOption(option, true);
				}
				//默认显示详情框
				myChart.dispatchAction({
					type: 'showTip',
					x: 10, // 屏幕上的 x 坐标
					y: 10, // 屏幕上的 y 坐标
					seriesIndex: 0,
					dataIndex: 30,
					// 本次显示 tooltip 的位置。只在本次 action 中生效。
					// 缺省则使用 option 中定义的 tooltip 位置。
					position: function(point, params, dom, rect, size) {
						return {
							right: '15%',
							top: '15%'
						};
					}
				});

				window.addEventListener("resize", function() {
					myChart.resize();
				});
			},
			onSohChart: function() { //SOH衰减曲线
				let self = this;
				var myChart = this.$echarts.init(document.getElementById("sohChart"));
				var option = {
					title: {
						text: 'SOH衰减曲线',
						left: 'center',
						textStyle: {
							color: '#fff',
							fontSize: '25'
						}
					},
					grid: {
						top: 60,
						bottom: 50
					},
					xAxis: {
						type: 'category',
						data: self.SOH.dateArray,
						axisLabel: {
							show: true,
							textStyle: {
								color: '#fff'
							}
						},
						axisLine: {
							show: false,
							lineStyle: {
								color: '#fff'
							},
						},
						// splitArea: {
						// 	show: true,
						// 	interval: function(index, value) {
						// 		return index > 271;
						// 	},
						// 	areaStyle: {
						// 		color: ['rgba(19, 18, 18, 0.1)', 'rgb(163, 114, 0,0.3)']
						// 	}
						// },
						interval: '100', //表示全部显示不间隔,auto:表示自动根据刻度个数和宽度自动设置间隔个数
					},
					yAxis: {
						name: 'SOH%',
						show: true,
						max: 100,
						min: 98,
						interval: 0.5,
						axisLine: {
							show: false,
							lineStyle: {
								color: '#fff'
							},
						},
						axisTick: {
							show: false
						},
						axisLabel: {
							show: true,
							textStyle: {
								color: '#fff'
							}
						},
						splitLine: {
							lineStyle: {
								color: 'gray',
							},
						},
						type: 'value',
						scale: true, //取消强制包含零刻度
					},
					tooltip: {
						backgroundColor :'rgba(50,50,50,0.7)',
						borderColor :'transparent',
						alwaysShowContent: true, //永远显示提示框内容
						trigger: 'axis',
						// axisPointer: {
						// 	type: 'cross', //十字准星指示器
						// },
						formatter: function(params) {
							var result =
								'<div style="border-top: 2px solid orange;text-align: center;border-bottom: 2px solid orange;padding: 10px 0px;"><span style="color: white;font-size: 16px;display: block;margin-bottom:5px;">SOH%</span><span style="display:block;font-size: 34px;color:orange;font-weight: bold;">' +
								params[0].data + '</span></div>';
							return result;
						},
					},
					series: [{
						data: self.SOH.previousData,
						type: 'line',
						color: 'white',
						symbol: 'none'
					}, {
						data: self.SOH.forecastData,
						type: 'line',
						color: 'orange',
						symbol: 'none',
						markArea: {
							silent: true,
							data: [
								[{
									xAxis: self.SOH.strtime
								}, {
									xAxis: self.SOH.endtime
								}]
							]
						},
					}]
				};
				if (option && typeof option === "object") {
					myChart.setOption(option, true);
				}
				//默认显示详情框
				myChart.dispatchAction({
					type: 'showTip',
					x: 10, // 屏幕上的 x 坐标
					y: 10, // 屏幕上的 y 坐标
					seriesIndex: 1,
					dataIndex: 280,
					// 本次显示 tooltip 的位置。只在本次 action 中生效。
					// 缺省则使用 option 中定义的 tooltip 位置。
					position: function(point, params, dom, rect, size) {
						return {
							right: '15%',
							top: '15%'
						};
					}
				});
				window.addEventListener("resize", function() {
					myChart.resize();
				});
			},


		}
	}
</script>

<style lang="scss" scoped>
	#temperatureChart,
	#voltageChart,#sohChart {
		border: 1px solid #007297 !important;
		width: 40%;
		height: 400px;
		display: inline-block;
		margin: 20px;
	}
</style>